// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 774 ? "72a92d46" : chunkId) + "." + {"35":"afbf5d3f55960b01","310":"dabcc34170b04f3e","394":"bec7e5abb1db4257","774":"5371a9322f94a8f7"}[chunkId] + ".js";
};